export const INTL_CURRENCIES = ["EUR", "USD", "GBP", "CAD", "AUD"] as const;
export type IntlCurrency = (typeof INTL_CURRENCIES)[number];

export type IntlProductKey = "map_single" | "map_gift_pair" | "map_gift_single" | "career_map" | "couples_map";

export const INTL_CURRENCY_LABEL: Record<IntlCurrency, string> = {
  EUR: "EUR €",
  USD: "USD $",
  GBP: "GBP £",
  CAD: "CAD CA$",
  AUD: "AUD A$",
};

const INTL_CURRENCY_SYMBOL: Record<IntlCurrency, string> = {
  EUR: "€",
  USD: "$",
  GBP: "£",
  CAD: "CA$",
  AUD: "A$",
};

export const INTL_PRICES: Record<IntlProductKey, Record<IntlCurrency, number>> = {
  map_single: { EUR: 19.9, USD: 21.99, GBP: 17.99, CAD: 29.99, AUD: 32.99 },
  map_gift_pair: { EUR: 29.9, USD: 32.99, GBP: 26.99, CAD: 44.99, AUD: 49.99 },
  map_gift_single: { EUR: 19.9, USD: 21.99, GBP: 17.99, CAD: 29.99, AUD: 32.99 },
  career_map: { EUR: 24.9, USD: 32.99, GBP: 26.99, CAD: 44.99, AUD: 49.99 },
  couples_map: { EUR: 49, USD: 54.99, GBP: 44.99, CAD: 74.99, AUD: 84.99 },
};

export const INTL_STRIPE_PRICE_IDS: Record<IntlProductKey, string> = {
  map_single: "price_1UEMksFmj61MWTivvvfibke6",
  map_gift_pair: "price_1UEMksFmj61MWTivznTCvFgA",
  map_gift_single: "price_1UEMktFmj61MWTivDBOHp3i7",
  career_map: "",
  couples_map: "price_1UEMktFmj61MWTivbb2nAmPM",
};

export const isIntlCurrency = (value: unknown): value is IntlCurrency =>
  typeof value === "string" && (INTL_CURRENCIES as readonly string[]).includes(value);

export function formatIntlMoney(amount: number, currency: IntlCurrency) {
  const symbol = INTL_CURRENCY_SYMBOL[currency];
  const hasCents = Math.round(amount * 100) % 100 !== 0;
  return `${symbol}${hasCents ? amount.toFixed(2) : String(Math.round(amount))}`;
}

export function formatIntlPrice(product: IntlProductKey, currency: IntlCurrency) {
  return formatIntlMoney(INTL_PRICES[product][currency], currency);
}